import $ from 'jquery';

// Initialize todos page dropdown selector
export function initTodosPage() {
  $('#todo_type').off('change.todos');
  $('#todo_type').on('change.todos', function() {
    const todoType = $('#todo_type').val().toLowerCase().replace(/ /g, '').replace('-', '_');
    window.location.href = '/todos/list/' + todoType;
  });
}

// Expose to global scope
window.initTodosPage = initTodosPage;

// Auto-initialize on turbo:load
$(document).on('turbo:load', function() {
  if ($('#todo_type').length > 0 && $('[data-section="todos"]').length > 0) {
    initTodosPage();
  }
});
